import { Link } from 'react-router-dom'
import { usePageSeo } from '@/hooks/usePageSeo'
import { getSeoCatalog } from '@/data/seoCatalog'
import './ServiceLanding.css'

export default function HtmlSitemap() {
  const catalog = getSeoCatalog()
  usePageSeo({
    title: 'HTML Sitemap | SecureFix London',
    description:
      'Browse all SecureFix phone, computer, console repair, product, business IT and recycling pages.',
    path: '/sitemap',
  })

  const groups = [
    {
      title: 'Core Pages',
      pages: catalog.filter((p) => p.kind === 'static'),
    },
    {
      title: 'Device Repair Categories & Brands',
      pages: catalog.filter((p) => p.kind === 'repair-category' || p.kind === 'repair-brand'),
    },
    {
      title: 'Device Model Repair Pages',
      pages: catalog.filter((p) => p.kind === 'repair-model'),
    },
    {
      title: 'Products & Accessories',
      pages: catalog.filter((p) => p.kind === 'product'),
    },
    {
      title: 'Business IT',
      pages: catalog.filter((p) => p.kind === 'business'),
    },
    {
      title: 'Recycling Topics',
      pages: catalog.filter((p) => p.kind === 'recycling-topic'),
    },
  ]

  return (
    <div className="service-landing-page site-page">
      <section className="service-landing-hero site-hero-bg">
        <div className="container service-landing-hero-inner">
          <h1>
            SecureFix <span className="accent">Sitemap</span>
          </h1>
          <p>
            {catalog.length} indexable pages for repairs, products, business IT and recycling across
            London EC1V.
          </p>
        </div>
      </section>
      <main className="service-landing-main">
        <div className="container">
          {groups.map((group) =>
            group.pages.length ? (
              <section key={group.title} className="service-landing-section">
                <h2>
                  {group.title}{' '}
                  <span className="accent">({group.pages.length})</span>
                </h2>
                <div className="service-landing-related-links">
                  {group.pages.map((page) => (
                    <Link key={page.path} to={page.path}>
                      {page.h1}
                    </Link>
                  ))}
                </div>
              </section>
            ) : null,
          )}
        </div>
      </main>
    </div>
  )
}
